import { render, staticRenderFns } from "./reset_password.vue?vue&type=template&id=43c189d4&lang=pug&"
import script from "./reset_password.ts?vue&type=script&lang=ts&"
export * from "./reset_password.ts?vue&type=script&lang=ts&"
import style0 from "./reset_password.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports